import { CalendarLegendProps, Container, Form, Group, UseMelioFormResults } from '@melio/penny';
import { DeliveryPreference } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import { useConfig } from '@melio/platform-provider';
import React from 'react';

import { PaymentFlowFormFields, PaymentFlowOnChangeHandlers } from '../../../types';

type DeliveryDateInputProps = {
  form: UseMelioFormResults<PaymentFlowFormFields>;
  onChange: PaymentFlowOnChangeHandlers['onDeliveryDateChange'];
  deliveryPreference?: DeliveryPreference | undefined;
  isLoading: boolean;
};

export const DeliveryDateInput = ({ form, onChange, deliveryPreference, isLoading }: DeliveryDateInputProps) => {
  const { formatMessage } = useMelioIntl();
  const { registerField } = form;

  const {
    settings: {
      payment: {
        scheduling: { hideScheduleDateIndication },
      },
    },
  } = useConfig();

  const legendItems: CalendarLegendProps[] = [
    {
      label: formatMessage(`activities.paymentFlow.form.content.deliveryDate.legend.deliveryDate`),
      variant: 'primary',
    },
  ];

  return (
    <Group variant="horizontal" width="full">
      {!hideScheduleDateIndication && (
        <Container width="full">
          <Form.DateField
            {...registerField('scheduleDate')}
            labelProps={{ label: formatMessage('activities.paymentFlow.form.content.scheduleDate.label') }}
            isReadOnly
          />
        </Container>
      )}
      <Container width="full">
        <Form.DateField
          {...registerField('deliveryDate')}
          labelProps={{ label: formatMessage('activities.paymentFlow.form.content.deliveryDate.label') }}
          placeholder={formatMessage('activities.paymentFlow.form.content.deliveryDate.placeholder')}
          legendItems={legendItems}
          minDate={deliveryPreference?.earliestDeliveryDate}
          isDisabled={!deliveryPreference}
          onChange={(date) => date && onChange(date)}
          isLoading={isLoading}
          showToday={false}
          excludeHolidays
          hideClear
        />
      </Container>
    </Group>
  );
};
